/**
 * Typed environment configuration.
 *
 * Vite exposes ``REACT_APP_*`` vars via ``import.meta.env`` (see
 * ``vite.config.ts``'s ``envPrefix``). Feature code must read from this
 * module, never from ``import.meta.env`` or ``process.env`` directly.
 */

const backendUrl = import.meta.env.REACT_APP_BACKEND_URL;

if (!backendUrl) {
  // Fail loud, fail fast. See Blueprint §2.10.
  // eslint-disable-next-line no-console
  console.error("REACT_APP_BACKEND_URL is not set — frontend will not function.");
}

export const config = Object.freeze({
  backendUrl: backendUrl ?? "",
  apiPrefix: "/api/v1",
  appName: "Orkexra",
  milestone: "M10 · Phase 1",
  blueprint: "v1.0",
});

export type Config = typeof config;
